import { useContext, useState } from "react";

import { Button } from "@shapr3d/frontend-lib";
import { createMsStoreParam, Platform, PlatformAPI } from "@shapr3d/frontend-lib";

import { originalIpadAppDownloadURL } from "../../config";
import { AppsFlyerContext } from "../../contexts/AppsFlyer";
import useDownloadUrl from "../../hooks/useDownloadUrl";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";
import IPadOSButton from "./IPadOSButton";
import MacOSButton from "./MacOSButton";
import WindowsButton from "./WindowsButton";

import style from "./DownloadSection.module.css"; // eslint-disable-line

const msStoreAppDownloadUrlBase = "https://apps.microsoft.com/store/detail/shapr3d/9N4K9QFV4XFC";

const DownloadSection = () => {
  const platform = PlatformAPI.getInstance().getPlatform();
  const isShaprSupportedPlatform = PlatformAPI.getInstance().isShaprSupportedPlatform();
  const tracker = useTracker();
  const { t, m } = useTranslation();
  const [showAllDownloadOptions, setShowAllDownloadoptions] = useState(!isShaprSupportedPlatform);
  const appsFlyer = useContext(AppsFlyerContext);

  const { data: downLoadUrl } = useDownloadUrl();

  const ipadAppStoreUrl = appsFlyer.generateUrl(false);
  const macAppDownloadURL = downLoadUrl?.update_url || ""; // TODO: quick fix, later add loading state

  const msStoreParam = createMsStoreParam();
  const msStoreAppDownloadUrl = `${msStoreAppDownloadUrlBase}?gclid=${msStoreParam}`;

  return (
    <div className={style.downloadSection}>
      <Heading type="h2" className={style.profileTitle}>
        {isShaprSupportedPlatform && !showAllDownloadOptions
          ? t(m.Download.GetShapr3DFor, { platform })
          : t(m.Download.GetShapr3D)}
      </Heading>
      <div>
        <div className={`${style.downloads} ${isShaprSupportedPlatform && style.underlined}`}>
          {(platform === Platform.Mac || showAllDownloadOptions) && (
            <MacOSButton downloadURL={macAppDownloadURL} preferred={platform === Platform.Mac} />
          )}
          {(platform === Platform.iPad || showAllDownloadOptions) && (
            <IPadOSButton
              downloadURL={ipadAppStoreUrl || originalIpadAppDownloadURL}
              preferred={platform === Platform.iPad}
            />
          )}
          {(platform === Platform.Windows || showAllDownloadOptions) && (
            <WindowsButton
              downloadURL={msStoreAppDownloadUrl}
              preferred={platform === Platform.Windows}
            />
          )}
        </div>
        {isShaprSupportedPlatform && (
          <Button
            variant="grayscale"
            id="download-section-show-all-button"
            onClick={() => {
              tracker.trackButtonClick({ elementId: "show-all-download-options" });
              setShowAllDownloadoptions(true);
            }}
            disabled={showAllDownloadOptions}
          >
            {t(m.Download.ShowAllDownloadOptions)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DownloadSection;
